import { useEffect, useMemo, useState } from 'react';
import { fetchFinanceCalendarEvents } from 'src/api/app-sync-services';
import { logger } from 'src/logger';
import { useAppContext } from 'src/components/context/AppContextProvider';
import { FinanceCalendarEventEntity } from 'src/api/interfaces';
import { useNavigationItems } from 'src/components/side-navigation-v2/useNavigationItems';
import { buildQuickLinks, GroupedSearchResults, performSearch } from '../GlobalSearchUtils';
import { PROFILE_DROPDOWN_ITEMS } from 'src/components/dfp-home-page/top-navigation/profile-dropdown-constants';

export interface UseFinSuiteSearchReturn {
  query: string;
  setQuery: (q: string) => void;
  results: GroupedSearchResults;
}

export const useFinSuiteSearch = (): UseFinSuiteSearchReturn => {
  const { parsedApplications, favoriteApplications, announcementsFlatEntity, homePageContent } = useAppContext();
  const navItems = useNavigationItems();

  const [query, setQuery] = useState('');

  const activeParsedApps = useMemo(() => parsedApplications.filter((app) => app.isActive), [parsedApplications]);
  const quickLinks = useMemo(() => buildQuickLinks(navItems, PROFILE_DROPDOWN_ITEMS), [navItems]);
  const welcomeContent = useMemo(() => homePageContent?.welcomeContentDetails || [], [homePageContent]);

  const [financeCalendarEvents, setFinanceCalendarEvents] = useState<FinanceCalendarEventEntity[]>([]);
  useEffect(() => {
    fetchFinanceCalendarEvents()
      .then(setFinanceCalendarEvents)
      .catch((error: unknown) => {
        logger.warn('Failed to fetch finance calendar events', { error: (error as Error)?.message });
        setFinanceCalendarEvents([]);
      });
  }, []);

  const results: GroupedSearchResults = useMemo(
    () => performSearch(query, activeParsedApps, announcementsFlatEntity, favoriteApplications, quickLinks, welcomeContent, financeCalendarEvents),
    [query, activeParsedApps, announcementsFlatEntity, favoriteApplications, quickLinks, welcomeContent, financeCalendarEvents]
  );

  return { query, setQuery, results };
};
